import { differenceInDays, intervalToDuration, isBefore } from 'date-fns'

type CountdownTimeLeft = {
  days: number
  hours: number
  minutes: number
  seconds: number
}

export const calculateTimeLeft = (endDate: Date): CountdownTimeLeft => {
  const now = new Date()
  const end = new Date(endDate)

  if (isBefore(end, now)) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0 }
  }

  const daysDiff = differenceInDays(end, now)

  const {
    hours = 0,
    minutes = 0,
    seconds = 0,
  } = intervalToDuration({ start: now, end })

  return { days: daysDiff, hours, minutes, seconds }
}
